module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-xl-5 offset-xl-1"
  }, [_c('b-jumbotron', {
    staticClass: "mb-0 pb-4 pt-4 h-100"
  }, [_c('h1', {
    staticClass: "display-4"
  }, [_vm._v("Onder de Boompjes")]), _vm._v(" "), _c('p', {
    staticClass: "lead mt-4"
  }, [_vm._v("\n\t\t\t\t\t\tSelecteer een veiling om te beginnen\n\t\t\t\t\t")]), _vm._v(" "), _c('auction-select', {
    staticClass: "mb-2",
    attrs: {
      "no-border-radius": false,
      "reset": true
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-xl-5 mt-sm-4 mt-xl-0"
  }, [_c('div', {
    staticClass: "row h-100 align-items-center"
  }, [_c('div', {
    staticClass: "col-6 pr-1 pb-2"
  }, [_c('dashboard-icon-button', {
    attrs: {
      "toName": "auctionList",
      "buttonTitle": "Veilingen",
      "iconName": "gavel"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-6 pl-1 pb-2"
  }, [_c('dashboard-icon-button', {
    attrs: {
      "toName": "categoryList",
      "buttonTitle": "Categorieën",
      "iconName": "cubes"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-6 pr-1 pb-2"
  }, [_c('dashboard-icon-button', {
    attrs: {
      "toName": "personList",
      "buttonTitle": "Personen",
      "iconName": "users"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-6 pl-1 pb-2"
  }, [_c('dashboard-icon-button', {
    attrs: {
      "toName": "itemsList",
      "buttonTitle": "Kavels",
      "iconName": "align-justify"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-6 pr-1"
  }, [_c('dashboard-icon-button', {
    attrs: {
      "toName": "tagList",
      "buttonTitle": "Tags",
      "iconName": "tags"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-6 pl-2"
  }, [_c('dashboard-icon-button', {
    attrs: {
      "toName": "planning",
      "buttonTitle": "Planning",
      "iconName": "calendar"
    }
  })], 1)])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-167f2459"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/DashboardLanding.vue
// module id = 1281
// module chunks = 1